module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAATCAYAAACDW21BAAABY0lEQVRIiWP8DwQMdARMpCg+deYCg29IIpgmG/wnEpw8ff6/hb3f/zkLloNpEJ8cQJSFMMtglqDzqWohLsPJtRSvhYQMBQWvT3ACdSwkZBnVfRiXUvBf39wNq4GUxCELrtT7+MkzhpryPIa84jqGSb1NDGYmBvCskV9SzzCxpxEuhg6K66djiPU2ZuLOFiCXaxg4/D987NT/4yfP/je38wWLkeKzorppcIwMMCyEGTplxnywRUeOnf6/cs1mcPCSGozoloEAI9hWJGBq68NgZW7MEBrkzXD46GmGRcvWMEhJijPISEsy5GQkMJga65NdyIAA2MLbt28zbNq0ieHLly8kaebh4WHw8/NjUFVVJVoPONGALJOUPAfUvAloCHGWfvnCA9TnB8TARFJcTLSFTBDNXxicnPYRbRkIgNSC9JAaKkwQzTwM+/Y5gV1NLACpBekB6SUF0D0OMVIprQFJFTA1AACMOZinTOSI8wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdtxtb1-1.png
// module id = 895
// module chunks = 0